import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { NotificationProvider } from './context/NotificationContext';
import { Web3Provider } from './context/Web3Context';
import { Layout } from './components/layout/Layout';
import { NotificationStack } from './components/common/Notification';
import { captureRefFromUrl } from './utils/referral';

import DashboardPage    from './pages/DashboardPage';
import InvestPage       from './pages/InvestPage';
import TeamPage         from './pages/TeamPage';
import RanksPage        from './pages/RanksPage';
import AdminPage        from './pages/AdminPage';
import NotFoundPage     from './pages/NotFoundPage';

import './styles/variables.css';
import './styles/global.css';
import './styles/animations.css';
import './styles/layout.css';
import './styles/components.css';
import './styles/dashboard.css';
import './styles/admin.css';
import './styles/mobile.css';

// Capture ?ref= into sessionStorage BEFORE React mounts so the value survives
// in-app navigation (e.g. Home → Invest strips the query string).
captureRefFromUrl();

function App() {
  return (
    <NotificationProvider>
      <Web3Provider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/"       element={<DashboardPage />} />
              <Route path="/invest" element={<InvestPage />} />
              <Route path="/team"   element={<TeamPage />} />
              <Route path="/ranks"  element={<RanksPage />} />
              <Route path="/admin"  element={<AdminPage />} />
              <Route path="*"       element={<NotFoundPage />} />
            </Routes>
          </Layout>
          <NotificationStack />
        </BrowserRouter>
      </Web3Provider>
    </NotificationProvider>
  );
}

export default App;
